<template>
    <transition appear name="fade-transition">
        <span class="display__number">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayNumber',
    extends: Display,
    computed: {
        displayValue() {
            if (this._.isNil(this.value) && this.fallback) {
                return this.fallback;
            }

            let display = this.toNumber(this.value, {
                maximumFractionDigits: this.getOption('decimals', 0),
                ...this.options
            });

            if (this.getOption('prefix')) {
                display = `${this.getOption('prefix')} ${display}`;
            }

            if (this.getOption('suffix')) {
                display += ` ${this.getOption('suffix')}`;
            }

            return display;
        }
    }
};
</script>

<style lang="scss" scoped>
.display__number {
    min-width: 7rem;
    text-align: right;
}
</style>
